module.exports = (function () {
    const { Application } = require('utils/framework');
    const {
        EventType, HydrationFinished, TestTargetReady, UserInfo, UserInfoLoaded
    } = require('constants/events');
    const InflatorComps = require('utils/framework/InflateComponents');
    const store = require('store/Store');
    const processUserFull = require('actions/UserActions').processUserFull;
    const urlUtils = require('utils/Url');
    const userUtils = require('utils/User');
    const forceRegisterModal = require('Actions').forceRegisterModal;
    const { getCreditCardTargeters } = require('actions/CreditCardActions');
    const targetersActions = require('actions/targetersActions');

    /** Function for Forced Registration Modal if url contains action=register
     * @param {object} userInfoData
     */
    const handleQueryParamsAction = function (userInfoData) {
        const actionParams = urlUtils.getParamsByName('action');

        if (actionParams && actionParams.indexOf('register') > -1) {
            if (userInfoData.profile.profileStatus !== 0 && !userInfoData.profile.beautyInsiderAccount) {
                store.dispatch(forceRegisterModal(true));
            } else if (userInfoData.profile.profileStatus === 0) {
                store.dispatch(forceRegisterModal(false));
            }
        }
    };

    const shouldShowWelcomeMats = function (userInfoData) {
        return userInfoData && userInfoData.profile && userInfoData.profile.welcomeMat;
    };

    /* User Info Service */
    Application.events.onLastLoadEvent(window, [HydrationFinished, UserInfoLoaded], function () {
        const userInfo = InflatorComps.services.UserInfo;
        const userInfoData = userInfo.data;
        const dataIsFromCache = userInfo.dataIsFromCache;
        store.dispatch(processUserFull(userInfoData, true, dataIsFromCache));

        const isLithiumSignInOrRegister = urlUtils.getParamsByName('launchSocialSignInFlow') || urlUtils.getParamsByName('launchSocialRegisterFlow');

        handleQueryParamsAction(userInfoData);

        Application.events.onLastLoadEvent(window, [TestTargetReady], () => {
            if (!shouldShowWelcomeMats(userInfoData) && !isLithiumSignInOrRegister) {
                userUtils.forceSignIn();
            }
        });

        store.dispatch(getCreditCardTargeters());

        store.dispatch(targetersActions.requestAndSetTargeters());

        Application.events.dispatchServiceEvent(UserInfo, EventType.Ready);
        Application.events.dispatchServiceEvent(UserInfo, EventType.ServiceCtrlrsApplied, true);
    });

    return null;
}());
